var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.49976C21.8284 1.49976 22.5 2.17133 22.5 2.99976V20.9998C22.5 21.8282 21.8284 22.4998 21 22.4998H3C2.17157 22.4998 1.5 21.8282 1.5 20.9998V2.99976C1.5 2.17133 2.17157 1.49976 3 1.49976H21ZM3 -0.000244141C1.34315 -0.000244141 0 1.3429 0 2.99976V20.9998C0 22.6566 1.34315 23.9998 3 23.9998H21C22.6569 23.9998 24 22.6566 24 20.9998V2.99976C24 1.3429 22.6569 -0.000244141 21 -0.000244141H3Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.99976C12.4142 5.99976 12.75 6.33554 12.75 6.74976V11.2498H17.25C17.6642 11.2498 18 11.5855 18 11.9998C18 12.414 17.6642 12.7498 17.25 12.7498H12.75V17.2498C12.75 17.664 12.4142 17.9998 12 17.9998C11.5858 17.9998 11.25 17.664 11.25 17.2498V12.7498H6.75C6.33579 12.7498 6 12.414 6 11.9998C6 11.5855 6.33579 11.2498 6.75 11.2498H11.25V6.74976C11.25 6.33554 11.5858 5.99976 12 5.99976Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8a148bfdfd5844554816bd7e71febfe7.svg";
export { ForwardRef as ReactComponent };